<template>
    <el-dialog title="信用卡还款" :visible.sync="dialogTableVisible" width="40%">
        <el-row class="border-bottom">
            <el-col :span="24" class="line-height">
                <el-col :span="4">信用卡持有人：</el-col>
                <el-col :span="19">{{this.tableData.cardholderName}}</el-col>
            </el-col>
            <el-col :span="24" class="line-height">
                <el-col :span="4">开户银行：</el-col>
                <el-col :span="19">{{this.tableData.bankName}}</el-col>
            </el-col>
            <el-col :span="24" class="line-height">
                <el-col :span="4">信用卡号：</el-col>
                <el-col :span="19">{{this.tableData.bankNumber}}</el-col>
            </el-col>
            <el-col :span="24">
                <!-- <el-table border style="width: 100%">
          <el-table-column label="扣款店铺">
          </el-table-column>
          <el-table-column prop="originaltotalCurrencyamount" label="扣款金额"></el-table-column>
          <el-table-column prop="originalTotalCny" label="转换人民币"></el-table-column>
          <el-table-column prop="fundtransferdate" label="时间"></el-table-column>
                </el-table>-->
                <table class="table" border="1" cellspacing="0" cellpadding="0">
                    <thead>
                        <tr>
                            <th>扣款店铺</th>
                            <th>扣款金额</th>
                            <th>转换人民币</th>
                            <th>时间</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>{{this.tableData.shopName}}</td>
                            <td>{{this.tableData.originaltotalCurrencyamount}}</td>
                            <td>{{this.tableData.originalTotalCny}}</td>
                            <td>{{this.tableData.fundtransferdate}}</td>
                        </tr>
                    </tbody>
                </table>
            </el-col>
            <el-col :span="24" class="line-height">
                <el-col :span="4">预还款总计金额：</el-col>
                <el-col :span="19">{{this.tableData.originalTotalCny}} CNY</el-col>
            </el-col>
            <el-col :span="24" class="line-height">
                <el-col :span="3">实还款金额：</el-col>
                <el-col :span="6">
                    <el-input v-model="repayAmount" @input="change($event)">
                        <template slot="append">CNY</template>
                    </el-input>
                </el-col>
            </el-col>
            <el-col :span="24" class="line-height">还款凭证：</el-col>
            <el-col :span="24">
                <el-upload
                    :action="action"
                    list-type="picture-card"
                    :on-success="handleAvatarSuccess"
                    :on-preview="handlePictureCardPreview"
                    :on-remove="handleRemove"
                    :headers="customHeaders"
                >
                    <i class="el-icon-plus" style="color: #0724ef;"></i>
                </el-upload>
                <el-dialog :visible.sync="dialogVisible" append-to-body>
                    <img width="100%" :src="dialogImageUrl" alt />
                </el-dialog>
            </el-col>
        </el-row>
        <div slot="footer" class="dialog-footer">
            <el-button @click="dialogTableVisible = false">取消</el-button>
            <el-button type="primary" @click="DetailedDetermine()">确定</el-button>
        </div>
    </el-dialog>
</template>

<script>
import { ajaxPost, Baseurl } from "../../../../api/api/api";
export default {
    name: "Detailed",
    data() {
        return {
            dialogTableVisible: false,
            dialogImageUrl: [],
            dialogVisible: false,
            tableData: "",
            financialeventgroupid: "",
            repayAmount: "",
            repayCredentialsList: [],
            role: "",
            arr: [],
            imageData: [],
            action: Baseurl + "imageController/uploadImage",
            customHeaders: { token: localStorage.getItem("token") }
        };
    },
    mounted() {},
    created() {
        this.role = JSON.parse(window.localStorage.getItem("role"));
    },
    methods: {
        init(e) {
            this.dialogTableVisible = true;
            this.tableData = e;
            console.log(this.tableData);
        },
        handlePictureCardPreview(file) {
            this.dialogImageUrl = file.url;
            this.dialogVisible = true;
        },
        //删除要上传的图片
        handleRemove(file, fileList) {
            this.imageData = [];
            for (var i = 0; i < fileList.length; i++) {
                this.imageData.push(fileList[i].response);
            }
        },
        //图片上传
        handleAvatarSuccess(file, fileList) {
            this.imageData.push(file);
        },
        //ajax图片上传
        DetailedDetermine() {
            // console.log(parameter)
            if (this.repayAmount === "") {
                this.$message.error("请输入还款金额");
            } else if (this.imageData.length === 0) {
                this.$message.error("请上传还款凭证");
            } else {
                for (var i = 0; i < this.imageData.length; i++) {
                    this.arr.push(this.imageData[i].data);
                }
                console.log(this.arr);
                var parameter = {
                    financialeventgroupid: this.tableData.financialeventgroupid,
                    repayAmount: this.repayAmount,
                    rid: this.role.rid,
                    repayCredentialsList: this.arr
                };
                ajaxPost(
                    Baseurl + "creditCardController/doRepayAmount",
                    parameter
                ).then(res => {
                    console.log(res.data);
                    if (res.data.code == 200) {
                        this.$message({
                            type: "success",
                            message: "还款成功"
                        });
                        this.$emit("refresh");
                    } else {
                        this.$message.error("还款失败");
                    }
                    this.dialogTableVisible = false;
                    this.repayAmount = "";
                    this.imageData = [];
                });
            }
        },
        change(e) {
            this.$forceUpdate();
        }
    }
};
</script>

<style lang="scss" scoped>
/deep/ {
    .el-dialog__body {
        padding: 13px 20px;
    }
}
.padding {
    padding: 5px 0;
}
.line-height {
    line-height: 35px;
}
.text-align {
    text-align: center;
    line-height: 30px;
}
img {
    width: 100%;
    height: 100%;
}
.table {
    width: 100%;
    height: 50px;
    border: solid 1px #c4c6ca;
}
.table th {
    height: 30px;
    text-align: center;
    color: #909399;
    border: solid 1px #c4c6ca;
}
.table td {
    height: 30px;
    text-align: center;
    border: solid 1px #c4c6ca;
}
</style>